export type Logger = {
  info: Console["log"];
  debug: Console["debug"];
  error: Console["error"];
};

export const defaultLogger: Logger = {
  info: console.log,
  debug: console.debug,
  error: console.error,
};

/**
 * Silent logger, mostly useful for testing cases where you may not want
 * a service logging out errors that you're expecting.
 */
export const noOpLogger: Logger = {
  // oxlint-disable-next-line typescript/no-explicit-any -- legacy any, may or may not be needed
  info: (..._: any[]) => void 0,
  // oxlint-disable-next-line typescript/no-explicit-any -- legacy any, may or may not be needed
  debug: (..._: any[]) => void 0,
  // oxlint-disable-next-line typescript/no-explicit-any -- legacy any, may or may not be needed
  error: (..._: any[]) => void 0,
};
